(function () {
  'use strict';

  /* Femzai wavy section dividers.
     Inserts a wave between every pair of visible sections inside #main.
     The wave takes the background color of one neighbour so each section
     appears to flow into the next with a soft wavy edge. */

  var PATHS = [
    'M0,64 L0,40 C240,10 480,10 720,32 C960,54 1200,54 1440,26 L1440,64 Z',
    'M0,64 L0,30 C180,52 420,60 720,38 C1020,16 1260,18 1440,40 L1440,64 Z',
    'M0,64 L0,36 C320,62 560,8 880,26 C1140,40 1300,22 1440,34 L1440,64 Z'
  ];

  function alphaOf(color) {
    if (!color || color === 'transparent') return 0;
    var m = color.match(/rgba?\(([^)]+)\)/);
    if (!m) return 1;
    var parts = m[1].split(',');
    return parts.length === 4 ? parseFloat(parts[3]) : 1;
  }

  function effectiveBg(section) {
    var candidates = [section];
    var i, kid;
    for (i = 0; i < section.children.length && i < 5; i++) {
      kid = section.children[i];
      if (/^(STYLE|SCRIPT|LINK|TEMPLATE)$/.test(kid.tagName)) continue;
      candidates.push(kid);
    }
    var scheme = section.querySelector('.color-scheme');
    if (scheme && candidates.indexOf(scheme) === -1) candidates.push(scheme);
    for (i = 0; i < candidates.length; i++) {
      var bg = getComputedStyle(candidates[i]).backgroundColor;
      if (alphaOf(bg) > 0.99) return bg;
    }
    return null;
  }

  function makeWave(color, index, mode) {
    var wrap = document.createElement('div');
    var cls = 'fz-wave fz-wave--' + mode;
    if (index % 2 === 1) cls += ' fz-wave--flip';
    wrap.className = cls;
    wrap.setAttribute('aria-hidden', 'true');
    wrap.setAttribute('data-fz-wave', '');
    var path = PATHS[index % PATHS.length];
    wrap.innerHTML =
      '<svg viewBox="0 0 1440 64" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path fill="' + color + '" d="' + path + '"/></svg>';
    return wrap;
  }

  function clear() {
    var old = document.querySelectorAll('[data-fz-wave]');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
  }

  function build() {
    var main = document.getElementById('main');
    if (!main) return;
    clear();

    var sections = [];
    var kids = main.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el.classList.contains('shopify-section') && el.offsetHeight > 40) {
        sections.push(el);
      }
    }

    for (var j = 0; j < sections.length - 1; j++) {
      var above = sections[j];
      var below = sections[j + 1];
      var bgAbove = effectiveBg(above);
      var bgBelow = effectiveBg(below);
      if (bgAbove && bgBelow && bgAbove === bgBelow) continue;

      var wave;
      if (bgBelow) {
        wave = makeWave(bgBelow, j, 'down');
      } else if (bgAbove) {
        wave = makeWave(bgAbove, j, 'up');
      } else {
        continue;
      }
      below.parentNode.insertBefore(wave, below);
    }
  }

  /* setTimeout, not requestAnimationFrame: rAF is suspended in background
     tabs, which would leave the page without dividers until repaint */
  var scheduled = null;
  function schedule() {
    if (scheduled) clearTimeout(scheduled);
    scheduled = setTimeout(function () {
      scheduled = null;
      build();
    }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && !document.querySelector('[data-fz-wave]')) schedule();
  });

  /* Keep the dividers in sync inside the theme editor */
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
})();
